const commonRoutes = [
    {
        path: '/403',
        name: '403',
        component: () => import('../../views/error/403.vue'),
        meta: { title: '403' }
    },
    {
        path: '/404',
        name: '404',
        component: () => import('../../views/error/404.vue'),
        meta: { title: '404' }
    },
    {
        path: '/home',
        name: 'home',
        component: () => import('../../views/HomeView.vue'),
        meta: { title: 'menu.home' }
    }
]

export default commonRoutes
